import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import axios from 'axios';
import { fetchApiAuth } from '../utils/api';
import { GetBvmSurveysParams, SaveBvmSurveyParams, GetBvmSurveyStatisticsParams, GetBvmCategoryDataParams, UpdateBvmCategoryParams, CreateOrUpdateBvmQuestionParams, DeleteBvmQuestionParams, ExportBvmSurveysParams } from './types';

export const getBvmSurveys = createAsyncThunk(
    'bvm/get-surveys',
    async (payload: GetBvmSurveysParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/bvm/surveys',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const saveBvmSurvey = createAsyncThunk(
    'bvm/save-survey',
    async (params: SaveBvmSurveyParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/bvm/save-survey',
                body: params,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const getBvmSurveyStatistics = createAsyncThunk(
    'bvm/get-survey-statistics',
    async (payload: GetBvmSurveyStatisticsParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/bvm/survey-statistics',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const getBvmCategoryData = createAsyncThunk(
    'bvm/get-category-data',
    async (payload: GetBvmCategoryDataParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/bvm/category-data',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const getBvmSurveysAdmin = createAsyncThunk(
    'bvm/get-surveys-admin',
    async () => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/bvm/surveys-admin',
                body: {},
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const updateBvmCategory = createAsyncThunk(
    'bvm/update-category',
    async (params: UpdateBvmCategoryParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/bvm/update-category',
                body: params,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateBvmQuestion = createAsyncThunk(
    'bvm/create-or-update-question',
    async (params: CreateOrUpdateBvmQuestionParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/bvm/create-or-update-question',
                body: params,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const deleteBvmQuestion = createAsyncThunk(
    'bvm/delete-question',
    async (params: DeleteBvmQuestionParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/bvm/delete-question',
                body: params,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const exportBvmSurveys = createAsyncThunk(
    'bvm/export-surveys',
    async (params: ExportBvmSurveysParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/bvm/export-surveys',
                body: params,
                responseType: 'blob',
            });
            return response;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);
